<template>
    <div class="reset">
      <div class="containers">
        <!--      <img class="got-mold-box" src="../images/bg/bg_box.png" alt="Box" />-->
        <div class="form" v-if="show_email || show_phone">
          <div class="title">
            Verify
          </div>
          <div class="input-wrap" v-show="show_email">
            <input
                type="text"
                class="input toLowerCase"
                name="email"
                placeholder="Enter your email address"
                v-model="enteredEmail"
                :class="{ invalid: errors.has('email') }"
                v-validate="'required|email'"
            />
            <span v-if="!validEmail" class="validate-error">Invalid email, please try again.</span>
            </div>
             <div class="label" v-show="show_email && show_phone">OR</div>
          <div class="input-wrap" v-show="show_phone">
            <input
                type="text"
                class="input"
                placeholder="Enter your phone number"
                v-model="enteredPhone"
                name="phone"
                v-validate="'required|min:16|phone_exist'"
                v-mask="'(###) ### - ####'"
            />
            <span v-if="!validPhone" class="validate-error">Invalid Phone number, please try again.</span>
            </div>
            <div class="btns-complate-wrap" id="btns-complate-wrap">
            </div>
          <button
            class="btn"
            @click.prevent="getFile"
          >
            Download PDF
          </button>
          <span
          class="download-txt non-downloading"
          :class="{ downloading: showPreloader }"
          >Waiting for download...</span>
        </div>
        <div v-else-if="validCheck" class="report-error">
          Loading.....
        </div>
        <div v-else class="report-error">
          Report Not Found.
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions } from "vuex";
  import axios from "axios";
  import { parseAndConvertKitId } from "./mixins/parseAndConvertKitId";
  import { ErrorBag } from "vee-validate";
  export default {
    name: "DownloadReport",
    mixins: [parseAndConvertKitId],
    data() {
      return {
        email: "",
        enteredEmail:"",
        phone: "",
        enteredPhone:"",
        kitId: "",
        id:"",
        show_email: false,
        show_phone: false,
        download:false,
        validPhone:true,
        validEmail:true,
        validCheck:true,
        api_url: process.env.VUE_APP_API_URL,
        showPreloader:false,

      };
    },
    methods: {
      ...mapActions(["checkverfication"]),
      async getFile() {
          if(this.show_phone && this.phone ==  `1${this.enteredPhone.replace(/[\s-()+]/g, "")}`){
            this.validPhone = true;
          } else {
            this.validPhone = false;
          }

          if(this.show_email && this.email == this.enteredEmail){
            this.validEmail = true;
          } else {
            this.validEmail = false;
          }
        if(this.validPhone || this.validEmail){
          this.showPreloader = true;
          await axios({
            url: `${this.api_url}/v1/testkits/${this.id}/report/pdf`,
            method: "GET",
            responseType: "blob" // important
          })
            .then(response => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",
                `KIT-ID-${this.convertKitId(this.kitId)}.pdf`
              );
              document.getElementById("btns-complate-wrap").appendChild(link);
              link.click();
            })
            .then(() => (this.showPreloader = false));
        }
      }
    },
    watch: {
      download() {
      }
    },
    async mounted(){
      this.kitId = this.$route.params.kitid;
      await axios.get(`v1/testkits/userVerficationCheck/${this.kitId}`)
      .then(response => {
        if(response.data.data != null){
          this.id = response.data.data.id;
          if(response.data.data.user.confirmed_email){
              this.show_email = true;
              this.email = response.data.data.user.email;
          }
          if(response.data.data.user.confirmed_phone){
              this.show_phone = true;
              this.phone = response.data.data.user.phone;
          }
          if(this.show_email == true || this.show_phone == true) {
              this.validCheck = true;
          } else {
              this.validCheck = false;
          }
        } else {
          this.validCheck = false;
        }
      });
    }
  };
  </script>
  
  <style scoped lang="scss">
  @import "../styles/_colors.scss";
  .reset {
    max-width: 100%;
    width: 100vw;
    height: auto;
    min-height: calc(100vh - 60px);
    display: flex;
    background-color: transparent;
    padding: 100px 0 0 0;
  }
  .form {
    padding: 36px 80px 40px 80px;
    background-color: $white;
    max-width: 500px;
    width: 50%;
    margin: 40px 0 0 auto;
    box-shadow: 0 3px 15px -9px $boxShadow;
    position: relative;
    border-radius: 15px;
    font-family: TTNormsMedium, sans-serif;
  }

  .report-error {
    padding: 36px 80px 40px 80px;
    background-color: $white;
    max-width: 500px;
    width: 50%;
    margin: 40px 0 0 auto;
    box-shadow: 0 3px 15px -9px $boxShadow;
    position: relative;
    border-radius: 15px;
    font-family: TTNormsMedium, sans-serif;
    text-align: center;
  }
  .title {
    color: $blue;
    font-family: TTNormsBold, sans-serif;
    font-size: 27px;
    text-align: center;
    margin: 0 0 36px 0;
  }
  
  .input {
    padding: 17px 20px;
    border-radius: 10px;
    color: $gray;
    width: 100%;
    font-size: 16px;
    font-family: TTNormsMedium, sans-serif;
    text-align: center;
    border: 1px solid #c5c5c5;
    outline: none;
  }
  .input:focus {
    border: 1px solid rgb(77, 144, 254);
  }
  .input.invalid:focus {
    border: 1px solid rgb(77, 144, 254);
  }
  .input::placeholder {
    color: $lightGray;
    font-size: 16px;
  }
  .input:disabled {
    border: none;
    color: #333;
    -webkit-text-fill-color: #333;
  }
  .btn {
    background-color: $green;
    width: 50%;
    margin: 36px auto 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $white;
    cursor: pointer;
    outline: none;
    border: 1px solid transparent;
    height: 45px;
    border-radius: 25px;
    font-size: 18px;
    transition: all 0.5s linear;
    font-family: TTNormsBold, sans-serif;
  }
  .btn.hide {
    display: none;
  }
  .btn:disabled {
    cursor: default;
    opacity: 0.5;
  }
  .back-btn {
    color: $green;
    border: none;
    cursor: pointer;
    outline: none;
    display: block;
    margin: 36px auto 0 auto;
    background-color: transparent;
    font-size: 16px;
    font-family: TTNormsMedium, sans-serif;
  }
  .back-btn.greenbg {
    background-color: $green;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $white;
    cursor: pointer;
    outline: none;
    border: 1px solid transparent;
    height: 45px;
    border-radius: 25px;
    margin: 20px 0 20px 0;
    font-size: 18px;
    transition: all 0.5s linear;
    font-family: TTNormsMedium, sans-serif;
  }
  .input-wrap {
  width: 100%;
  margin: 20px 0 20px 0;
  
}
  @media screen and (max-width: 1000px) {
    .form {
      padding: 30px;
      max-width: 450px;
    }
    .got-mold-box {
      bottom: 200px;
    }
  }
  @media screen and (max-width: 768px) {
    .reset {
      background: url("../images/bg/sky-mobile.jpg");
      padding: 90px 0 0 0;
    }
    .form {
      margin: 0 auto;
      width: 100%;
    }
  }
  @media (max-width: 568px) {
    .form {
      padding: 36px 20px 40px 20px;
      max-width: 100%;
    }
  }
  .success-msg {
    font-size: 14px;
    color: green;
  }
  .failed-msg {
    font-size: 14px;
    color: #ca3232;
  }
  .download-txt {
    font-size: 14px;
    color: #03409a;
    padding: 0 0 0 5px;
    font-family: GothamPro, sans-serif;
  }
  .non-downloading {
    opacity: 0;
  }
  .downloading {
    opacity: 1;
    margin-left: 115px;
    font-size: 10px;
    color: #6cc24a;
  }
  .btns-complate-wrap{
   display: none;
  }
  .containers {
    width: 67%;
    position: relative;
  }
  .label{
    color: #d2caca;
    width: 100%;
    font-size: 16px;
    font-family: TTNormsMedium, sans-serif;
    text-align: center;
  }
  </style>
  